import axios, { AxiosPromise } from 'axios'
import { graphCmsProjectUrls } from 'src/utils/graphcms'

export const getOddleEatsBanner = (
  countryCode: string
): AxiosPromise<GraphCms.OddleEatsBanner> => {
  const url = graphCmsProjectUrls[countryCode]
  return axios({
    url,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      query: `
        query MyQuery {
          oddleShopMarketingBanners {
            androidLink
            iosLink
            mobileImage {
              url
            }
            desktopImage {
              url
            }
          }
        }
      `
    }
  })
}
